import sharedEnums from "shared/enums.json"

export const NOOS_PRODUCT_TABLE_ID = "noos-product-table"
export const NOOS_FORECAST_UPDATES_TABLE_ID = "noos-forecast-updates"
export const FORECAST_CALENDAR_PRODUCT_TABLE_ID = "forecasts-calendar-product-table"
export const INVENTORY_PAGE_TABLE_ID = "inventory-product-table"
export const INVENTORY_CALENDAR_PRODUCT_TABLE_ID = "inventory-calendar-product-table"
export const PHASING_OUT_PAGE_TABLE_ID = "phasing-out-product-table"
export const CUSTOMER_INSIGHTS_TABLE_ID = "customerTable"
export const COMPARISON_TABLE_ID = "comparison-table"
export const AVAILABILITY_TABLE_ID = "availablity-table"
export const SUGGESTED_VARIANT_ACTIVATIONS_TABLE_ID = "suggested-variant-activations"
export const NEEDS_ATTENTION_TABLE_ID = "needs-attention"
export const NOOS_NEW_PRODUCTS_TABLE_ID = "noos-new-products"
export const PM_LINKED_VARIANTS_TABLE_ID = "pm-linked-variants"
export const PM_REGULAR_VARIANTS_TABLE_ID = "pm-regular-variants"
export const PM_PHASED_OUT_SKUS_TABLE_ID = "pm-phased-out-skus"
export const PM_HIDDEN_SKUS_TABLE_ID = "pm-hidden-skus"
export const PM_GHOST_TOWN_TABLE_ID = "pm-ghost-town"
export const PM_INBOX_TABLE_ID = "pm-inbox"
export const INCOMING_ORDERS_CALENDAR_TABLE_ID = "incoming-orders-calendar"
export const REPLENISHMENT_SUGGESTIONS_TABLE_ID = "order-suggestions"
export const PURCHASE_PLAN_TABLE_ID = "purchase-plan"
// New id on purpose — the SKU-leaf table's persisted grid state is incompatible with the
// old variant-level Quantities table.
export const PURCHASE_PLAN_SKU_QUANTITIES_TABLE_ID = "purchase-plan-sku-quantities-table"
export const NOOS_BUY_TABLE_ID = "noos-buy-quantities"
export const NOOS_BUY_CAPACITY_TABLE_ID = "noos-buy-capacity"
export const NOOS_CAPACITY_PLANNING_TABLE_ID = "noos-capacity-planning-order-calendar"
export const PURCHASE_PLAN_CAPACITY_TABLE_ID = "purchase-plan-capacity"
export const PURCHASE_PLAN_GREIGE_TABLE_ID = "purchase-plan-greige"
export const SUPPLY_PLAN_COLLECTION_GREIGE_TABLE_ID = "supply-plan-collection-greige"
export const SUPPLY_PLAN_COLLECTION_CAPACITY_TABLE_ID = "supply-plan-collection-capacity-v2"
export const NOOS_SUPPLY_PLAN_GREIGE_TABLE_ID = "noos-supply-plan-greige"
// Bumped to reset saved column layouts when the trigger columns change.
export const NOOS_SUPPLY_PLAN_TRIGGERS_TABLE_ID = "noos-supply-plan-order-suggestions-v4"
export const NOOS_SUPPLY_PLAN_AVAILABILITY_TABLE_ID = "noos-supply-plan-availability"
export const COLLECTIONS_OVERVIEW_TABLE_ID = "overview-collection-current"
export const COLLECTIONS_DEMAND_PLAN_TAB_TABLE_ID = "demand-plan-tab-collection"
export const COLLECTIONS_DEMAND_TRIM_TAB_TABLE_ID = "trim-variants-table"
export const COLLECTIONS_VARIANTS_SPLITS_TABLE_ID = "variants-splits-table"
export const COLLECTIONS_CUSTOMERS_TABLE_ID = "customers-collection"
export const COLLECTIONS_PERFORMANCE_TABLE_ID = "products-collection"
export const DEMAND2_PERFORMANCE_TABLE_ID = "demand2-portfolio-performance"
export const PURCHASE_ORDER_UPDATE_TABLE_ID = "purchase-order-update"
export const BUDGET_SALES_PRICES_TABLE_ID = "budget-sales-prices"
export const BUDGET_REPORT_VARIANT_TABLE_ID = "budget-report-variant-table"
export const FORECAST_REPORTING_SALES_TABLE_ID = "forecastreporting-sales-table"
export const FORECAST_REPORTING_COMPARISON_TABLE_ID = "forecast-comparison"

export const TABLES_THAT_CAN_BE_UPDATED = sharedEnums.ingestionFunctionNames
export const FORECAST_TABLES_THAT_CAN_BE_UPDATED = sharedEnums.ingestionFunctionNames.filter(
  (name) => !sharedEnums.ingestionFunctionNamesNotRelevantForForecast.includes(name),
)
export const MARKET_STRATEGY_CHANNELS_TABLE_ID = "market-strategy-channels"
